import { hasCapability, type User } from "../base";

export const taskStatus = {
  update: (user: User) => hasCapability(user, "taskStatus.update"),
};
